import axios from "axios";
import React, { lazy, Suspense, useCallback, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { IoMdEye } from "react-icons/io";
import { Input, SubTitle } from "../../Components/CustomComponents/index.js";
import SimpleTable from "../../Components/Table/SimpleTable.js";
import Pagination from "../../Components/Pagination/Pagination.js";
import Toast from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
//
import { debounce } from "lodash";
import moment from "moment/moment.js";
import {
  Badge,
  Col,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import { useDispatch } from "react-redux"; // for getting and setting data into
import NameImageComponent from "../../Components/CustomComponents/NameImageComponent.js";
import { OrderStatus } from "../../constants.js";
import { useGetAllOrdersQuery, useChangeOrderStatusMutation, useLazyGetOrderDetailQuery } from "../../Data/services/ordersApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";

const OrderDetailModal = lazy(() =>
  import("../../Components/Modals/OrderDetailModal.js")
);
const AssignDriverModal = lazy(() =>
  import("../../Components/Modals/AssignDriverModal.jsx") 
);
// const NameImageComponent = lazy(() =>
//   import("../../Components/CustomComponents/NameImageComponent.js")
// );

const OrderManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  // const [forBlock, setForBlock] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [assignDriverModal, setAssignDriverModal] = useState(false);
  const [selectedOrderForDriver, setSelectedOrderForDriver] = useState(null);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQueryByUser, setSearchQueryByUser] = useState("");
  const [searchQueryByRestaurant, setSearchQueryByRestaurant] = useState("");

  const [orderDate, setOrderDate] = useState("");

  const [orderBy, setOrderBy] = useState("user_name");
  const [order, setOrder] = useState("Asc");

  // const debouncedSearchUser = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [
  //         item.user.firstname,
  //         item.user.lastname,
  //         item.user.username,
  //         item.user.email,
  //       ]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );
  //     //
  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const { data, isSuccess, isLoading, isFetching, isError, refetch } =
    useGetAllOrdersQuery(
      {
        search_user: searchQueryByUser.length >= 3 ? searchQueryByUser : "",
        search_restaurant:
          searchQueryByRestaurant.length >= 3 ? searchQueryByRestaurant : "",
        limit: pageSize,
        page: currentPage,
        orderBy: orderBy,
        order: order,
        ...(orderDate && { order_date: orderDate }),
      },
      { refetchOnMountOrArgChange: true }
    );

  const [changeOrderStatus, { isLoading: isChangingStatus }] = useChangeOrderStatusMutation();
  const [getOrderDetail] = useLazyGetOrderDetailQuery();

  // const debouncedSearchRestaurant = useCallback(
  //   debounce((query) => {
  //     const filtered = dummy_data.filter((item) =>
  //       [
  //         item.restaurant.firstname,
  //         item.restaurant.lastname,
  //         item.restaurant.name,
  //         item.restaurant.email,
  //       ]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchByUser = (event) => {
    const query = event.target.value;
    setSearchQueryByUser(query);
  };

  const handleSearchByRestaurant = (event) => {
    const query = event.target.value;
    setSearchQueryByRestaurant(query);
  };

  const handleOrderStatusChange = async (orderSlug, newStatus, orderData) => {
    try {
      console.log(orderSlug, "orderSlug", newStatus, "newStatus", orderData, "orderData")
      const response = await changeOrderStatus({
        id: orderSlug,
        order_status: newStatus,
      });

      if (response.error) {
        Toast(
          response.error?.data?.message || "Failed to update order status",
          "error"
        );
      } else if (response.data && response.data.code === 200) {
        Toast(response.data.message || "Order status updated successfully", "success");
        refetch();
        
        // If status changed to Ready For Delivery (3), fetch fresh order data to check rider status
        if (newStatus === 3) {
          console.log("Status changed to Ready For Delivery, fetching fresh order data...");
          
          try {
            const orderDetailResponse = await getOrderDetail({ slug: orderSlug });
            console.log("Fresh order data:", orderDetailResponse);
            
            if (orderDetailResponse.data && orderDetailResponse.data.data) {
              const freshOrderData = orderDetailResponse.data.data;
              const hasRider = freshOrderData.rider && freshOrderData.rider.slug;
              
              console.log("Fresh order rider:", freshOrderData.rider);
              console.log("Has rider:", hasRider);
              
              if (!hasRider) {
                console.log("No rider assigned, opening driver assignment modal");
                setSelectedOrderForDriver(freshOrderData);
                setAssignDriverModal(true);
              } else {
                console.log("Order already has a rider assigned:", freshOrderData.rider);
              }
            }
          } catch (detailError) {
            console.error("Error fetching order details:", detailError);
            // Fallback to original logic if fetch fails
            const hasRider = orderData?.rider && orderData?.rider?.slug;
            if (!hasRider) {
              setSelectedOrderForDriver(orderData);
              setAssignDriverModal(true);
            }
          }
        }
      }
    } catch (error) {
      Toast("An error occurred while updating order status", "error");
    }
  };

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data || []);
      setDataFetched(true);

      if (!data.data || data.data.length === 0) {
        setIndicationMessage("No Orders Found");
      }
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      setRowData([]);
      setTotalRecords(0);
      setTotalPages(0);
      setDataFetched(true);
      setIndicationMessage("No Orders Found");
    }
  }, [isError]);

  const handleDetailModalOpen = () => {
    setDetailModal(true);
  };

  const handleDetailModalClose = () => {
    // console.log("close");
    setDetailModal(false);
    setEditedData("");
  };

  const handleAssignDriverModalClose = () => {
    setAssignDriverModal(false);
    setSelectedOrderForDriver(null);
  };

  const handleDriverAssignSuccess = () => {
    refetch();
  };

  // const deleteData = (id) => {
  //   console.log(id);
  //   axios(`https://jsonplaceholder.typicode.com//posts/${id}`)
  //     .then((res) => {
  //       // console.log(res.data)
  //       // console.log(res.status)
  //       // setData(res.data);
  //       if (res.status === 200) {
  //         Toast("Deleted Successfully", "success");
  //         handleDetailModalClose();
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       console.log(e.message);
  //       Toast("Something went wrong.", "error");
  //       // handleBlockModalClose();
  //       // setIndicationMessage("Something went wrong, refresh again");
  //     });
  // };

  // const handleEditModalOpen = () => {
  //   setEditModal(true);
  // };

  // const handleEditModalClose = () => {
  //   setEditModal(false);
  //   setEditedData("");
  // };

  // const handleAddUser = () => {
  //   setEditModal(true);
  // };

  // const handleBlockOrUnblock = (userSlug, actionType) => {
  //   console.log(userSlug);
  //   console.log(actionType);
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //     handleDetailModalClose();
  //   }, 2000);
  // };

  // useEffect(() => {
  //   getData();
  //   return () => { };
  // }, []);

  // const getData = () => {
  //   // axios('https://jsonplaceholder.typicode.com/comments').then((res) => {
  //   axios("https://jsonplaceholder.typicode.com/users")
  //     .then((res) => {
  //       // console.log(res.data)
  //       // console.log(res.status)
  //       setIndicationMessage("");

  //       setData(res.data);

  //       setData((prv) => [...prv, res.data]); // todo:

  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setIndicationMessage("Something went wrong, refresh again");
  //     });
  // };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "order_id",
      text: "Order #",
      sort: true,
      headerStyle: {
        width: "80px",
        minWidth: "80px",
      },
      style: {
        width: "80px",
        minWidth: "80px",
      },
      onSort: (field, order) => {
        setOrderBy("order_id");
        setOrder(order === "desc" ? "Desc" : "Asc");
      },
      formatter: (cellContent, row) => {
        return (
          <span className={styles.orderNumber}>
            {row.order_id}
          </span>
        );
      },
    },
    {
      dataField: "username",
      text: "Customer",
      sort: true,
      headerStyle: {
        width: "150px",
        minWidth: "150px",
      },
      style: {
        width: "150px",
        minWidth: "150px",
      },
      onSort: (field, order) => {
        setOrderBy("user_name");
        setOrder(order === "desc" ? "Desc" : "Asc");
      },
      formatter: (cellContent, row) => {
        const userName = row.user.firstname + " " + row.user.lastname;
        return (
          <div className={styles.userCell}>
            <NameImageComponent name={userName} image={row.user.image_url} />
          </div>
        );
      },
    },
    {
      dataField: "restaurant_name",
      text: "Restaurant",
      sort: true,
      headerStyle: {
        width: "180px",
        minWidth: "180px",
      },
      style: {
        width: "180px",
        minWidth: "180px",
      },
      onSort: (field, order) => {
        setOrderBy("restaurant_name");
        setOrder(order === "desc" ? "Desc" : "Asc");
      },
      formatter: (cellContent, row) => {
        return (
          <div className={styles.restaurantCell}>
            <NameImageComponent
              name={row.restaurant.name}
              image={row.restaurant.image_url}
            />
          </div>
        );
      },
    },
    {
      dataField: "order_items",
      text: "Items",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "80px",
        minWidth: "80px",
      },
      style: {
        width: "80px",
        minWidth: "80px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className={styles.itemCount}>
            {row.order_items.length}
          </span>
        );
      },
    },
    {
      dataField: "subtotal",
      text: "Subtotal",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      style: {
        width: "100px",
        minWidth: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className={styles.amount}>
            {row.subtotal}
          </span>
        );
      },
    },
    {
      dataField: "delivery_charges",
      text: "Delivery",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "90px",
        minWidth: "90px",
      },
      style: {
        width: "90px",
        minWidth: "90px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className={styles.amount}>
            {row.delivery_charges}
          </span>
        );
      },
    },
    {
      dataField: "platform_fee",
      text: "Platform Fee",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      style: {
        width: "100px",
        minWidth: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className={styles.amount}>
            {row.platform_fee}
          </span>
        );
      },
    },
    {
      dataField: "total_amount",
      text: "Total Amount",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "120px",
        minWidth: "120px",
      },
      style: {
        width: "120px",
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className={`${styles.amount} ${styles.totalAmount}`}>
            {row.total_amount}
          </span>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Order Date",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "120px",
        minWidth: "120px",
      },
      style: {
        width: "120px",
        minWidth: "120px",
      },
      onSort: (field, order) => {
        setOrderBy("order_date");
        setOrder(order === "desc" ? "Desc" : "Asc");
      },
      formatter: (cellContent, row) => {
        const agoFormat = moment(row.createdAt).fromNow();
        return (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(row.createdAt)}
          >
            <span className={styles.dateCell}>
              {agoFormat}
            </span>
          </OverlayTrigger>
        );
      },
    },
    {
      dataField: "order_status_title",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "120px",
        minWidth: "120px",
      },
      style: {
        width: "120px",
        minWidth: "120px",
      },
      onSort: (field, order) => {
        setOrderBy("order_status");
        setOrder(order === "desc" ? "Desc" : "Asc");
      },
      formatter: (cellContent, row) => {
        const isCompleted = row.order_status_title === OrderStatus.COMPLETED;
        const isUnaccepted = row.order_status === 1;
        const allOrderStatusOptions = [
          { value: 1, label: OrderStatus.UNACCEPTED_ORDER },
          { value: 2, label: OrderStatus.ACCEPTED },
          { value: 3, label: OrderStatus.READY_FOR_DELIVERY },
          { value: 4, label: OrderStatus.REACHED_AT_SHOP },
          { value: 5, label: OrderStatus.PICKED_ORDER },
          { value: 6, label: OrderStatus.ON_THE_WAY },
          { value: 7, label: OrderStatus.ORDER_DELIVERED },
          { value: 8, label: OrderStatus.COMPLETED },
        ];

        // Filter out "Unaccepted Order" option if order is already accepted or beyond
        // This prevents going backwards in the order flow
        const orderStatusOptions = isUnaccepted 
          ? allOrderStatusOptions 
          : allOrderStatusOptions.filter(option => option.value !== 1);

        const getStatusBgColor = (status) => {
          if (
            status === OrderStatus.ACCEPTED ||
            status === OrderStatus.COMPLETED ||
            status === OrderStatus.ORDER_DELIVERED
          ) {
            return "success";
          } else if (
            status === OrderStatus.ON_THE_WAY ||
            status === OrderStatus.PICKED_ORDER ||
            status === OrderStatus.REACHED_AT_SHOP
          ) {
            return "warning";
          } else if (status === OrderStatus.UNACCEPTED_ORDER) {
            return "danger";
          }
          return "secondary";
        };

        return (
          <select
            className={`form-select form-select-sm ${styles.statusDropdown}`}
            value={row.order_status || ""}
            onChange={(e) => handleOrderStatusChange(row.slug, parseInt(e.target.value), row)}
            disabled={isCompleted || isChangingStatus}
            style={{
              backgroundColor: isCompleted ? "#d3d3d3" : "",
              cursor: isCompleted ? "not-allowed" : "pointer",
              fontSize: "0.875rem",
              padding: "0.25rem 2.25rem 0.25rem 0.5rem",
            }}
          >
            
            {orderStatusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "120px",
        minWidth: "120px",
      },
      style: {
        width: "120px",
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        if (row.slug) {
          return (
            <div className={`d-flex justify-content-center align-items-center ${styles.mobileActions}`}>
              <div
                className={`d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 actionButton`}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleDetailModalOpen();
                }}
              >
                <span className={`d-flex align-items-center pe-1`}>
                  <IoMdEye />
                </span>
                <span className="d-none d-xl-block">View</span>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {detailModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <OrderDetailModal
            handleModalClose={handleDetailModalClose}
            rowData={editedData}
            // onAction={handleBlockOrUnblock}
            loading={loading}
          />
        
        </Suspense>
      ) : (
        ""
      )}

      {assignDriverModal && selectedOrderForDriver ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <AssignDriverModal
            handleModalClose={handleAssignDriverModalClose}
            orderData={selectedOrderForDriver}
            onAssignSuccess={handleDriverAssignSuccess}
          />
        </Suspense>
      ) : (
        ""
      )}

      {
        //   editModal ? (
        //   <EditUserModal
        //     handleEditModalClose={handleEditModalClose}
        //     data={editedData}
        //   />
        // ) : (
        //   ""
        // )
      }
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col xs={12} md={6} className="mb-3 mb-md-0">
            <div>
              <SubTitle text={"Orders Management"} classes="text-black" />
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className={styles.searchControls}>
              <div className={styles.searchRow}>
                <div className={styles.searchItem}>
                  <label className={styles.searchLabel}>Filter by Date</label>
                  <Input
                    type="date"
                    placeholder="Select Date"
                    value={orderDate}
                    onChange={(e) => setOrderDate(e.target.value)}
                    className={styles.searchInput}
                  />
                </div>
                <div className={styles.searchItem}>
                  <label className={styles.searchLabel}>Search by User</label>
                  <Input
                    placeholder="Search users..."
                    value={searchQueryByUser}
                    onChange={handleSearchByUser}
                    className={styles.searchInput}
                  />
                </div>
                <div className={styles.searchItem}>
                  <label className={styles.searchLabel}>Search by Restaurant</label>
                  <Input
                    placeholder="Search restaurants..."
                    value={searchQueryByRestaurant}
                    onChange={handleSearchByRestaurant}
                    className={styles.searchInput}
                  />
                </div>
              </div>
              <div className={styles.filterActions}>
                <button 
                  className={styles.clearFiltersBtn}
                  onClick={() => {
                    setOrderDate("");
                    setSearchQueryByUser("");
                    setSearchQueryByRestaurant("");
                  }}
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </Col>
        </Row>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add User"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      {!dataFetched || isLoading ? (
        <CustomLoader />
      ) : (
        <div className={styles.mainTable}>
          <div className={styles.tableContent}>
            <SimpleTable
              data={rowData}
              columns={columns}
              indication={indication}
              totalRecords={totalRecords}
              totalPages={totalPages}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setPageSize={setPageSize}
              refetch={refetch}
              showPagination={false}
            />
          </div>
        </div>
      )}

      {/* Pagination outside the table div */}
      {dataFetched && isSuccess && totalPages > 1 && (
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalRecords={totalRecords}
            pageSize={pageSize}
            onPageChange={(page) => {
              setCurrentPage(page);
              if (refetch) {
                refetch();
              }
            }}
            onPageSizeChange={(newSize) => {
              setPageSize(newSize);
              setCurrentPage(1);
              if (refetch) {
                refetch();
              }
            }}
            showPageSizeSelector={true}
            showRecordsInfo={true}
          />
        </div>
      )}
    </div>
  );
};

const renderTooltip = (date) => (
  <Tooltip id="button-tooltip">
    {moment(date).format("YYYY-MM-DD HH:mm:ss")}
  </Tooltip>
);

export default OrderManagementScreen;
